'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_OPTIONS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.cleanUsedTraits = cleanUsedTraits;

var _constants = require('../constants');

var _nonCanonical = require('./nonCanonical');

var _getDeviceType = require('./getDeviceType');

var _getDeviceType2 = _interopRequireDefault(_getDeviceType);

var _getBettingAccountLoggedInStatus = require('./cookie/getBettingAccountLoggedInStatus');

var _getBettingAccountLoggedInStatus2 = _interopRequireDefault(_getBettingAccountLoggedInStatus);

var _getUserName = require('./cookie/getUserName');

var _getUserName2 = _interopRequireDefault(_getUserName);

var _getUserId = require('./cookie/getUserId');

var _getUserId2 = _interopRequireDefault(_getUserId);

var _commonTraits = require('./commonTraits');

var _getUTMParams = require('./utm/getUTMParams');

var _getUTMParams2 = _interopRequireDefault(_getUTMParams);

var _traits = require('../traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
    integrations: {
        All: true
    }
};

var usedTraits = {};

function cleanUsedTraits() {
    usedTraits = {};
}

function identify() {
    var _extends2;

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

    var userIdLocal = props[_traits.TRAIT_USER_ID] ? props[_traits.TRAIT_USER_ID] : (0, _getUserId2.default)();
    var emailLocal = props[_traits.TRAIT_EMAIL] ? props[_traits.TRAIT_EMAIL] : (0, _getUserName2.default)();

    var checkloginCookie = (0, _getUserId2.default)();

    // Overwrite segment defaults to use a non canonical values
    var properties = {
        path: (0, _nonCanonical.getNonCanonicalPath)(),
        url: (0, _nonCanonical.getNonCanonicalUrl)()
    };

    properties[_traits.TRAIT_USER_NAME] = emailLocal;
    properties[_traits.TRAIT_EMAIL] = emailLocal;
    properties[_traits.TRAIT_USER_ID] = userIdLocal;

    var commonTraits = (0, _commonTraits.getCommonTraits)();
    if (commonTraits && commonTraits[_traits.TRAIT_SITE_SECTION]) {
        properties[_traits.TRAIT_SITE_SECTION] = commonTraits[_traits.TRAIT_SITE_SECTION];
        properties[_traits.TRAIT_SITE_SUB_SECTION_1] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_1];
        properties[_traits.TRAIT_SITE_SUB_SECTION_2] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_2];
    }

    var bettingAccountLoggedIn = (0, _getBettingAccountLoggedInStatus2.default)();

    properties = (0, _extends4.default)((_extends2 = {}, (0, _defineProperty3.default)(_extends2, _traits.TRAIT_DEVICE_TYPE, (0, _getDeviceType2.default)()), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_LOGGED_IN_STATUS, checkloginCookie ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS, bettingAccountLoggedIn ? 'Logged In' : 'Logged Out'), _extends2), properties, (0, _getUTMParams2.default)(), props);

    var keys = Object.keys(properties);
    var isSameTraits = keys.every(function (prop) {
        return properties[prop] === usedTraits[prop];
    });

    if (isSameTraits) {
        return Promise.resolve();
    }

    usedTraits = Object.assign({}, properties);

    return new Promise(function (resolve) {
        // Segment Identify event
        if (!global.analytics) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        if (userIdLocal) {
            global.analytics.identify(userIdLocal, properties, options, resolve);
        } else {
            global.analytics.identify(properties, options, resolve);
        }
    });
}

exports.default = identify;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/identify.js
// module id = 222
// module chunks = 1